module.exports = __webpack_public_path__ + "img/LogoWhite.92069ed4.png";